import React from "react";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useSelector } from "react-redux";

const KYCCompleted = ({ userId, kycStatus }) => {
  
  const theme=useSelector((data)=>data.themeValue.colors)
  const themeMode=useSelector((data)=>data.themeValue.theme)
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={4}
        sx={{
          p: 5,
          borderRadius: 4,
          textAlign: "center",
          background: "#ffffff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          background: theme.background,
          boxShadow: themeMode==="light"?"0px 4px 20px rgba(0, 0, 0, 0.1)":"0px 4px 20px rgba(255, 255, 255, 0.1)",
        }}
      >
        <Typography variant="h4" fontWeight="bold" sx={{color:theme.text}} gutterBottom>
          KYC Status
        </Typography>

        <Typography
          variant="h6"
          color="success.main"
          fontWeight="600"
          sx={{ mb: 4 }}
        >
          {kycStatus || "Completed"}
        </Typography>

        <Divider sx={{ my: 3, backgroundColor:theme.text}} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            alignItems: "center",
            mt: 3,
          }}
        >
          {/* PAN Card Verified */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 3,
              backgroundColor:themeMode==="light"?"0px 4px 20px rgb(255, 255, 255)":"0px 4px 20px rgba(255, 255, 255, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // transition: "0.3s",
              // "&:hover": { backgroundColor: "#f1f1f1" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{color:theme.text}}>
              PAN Card
            </Typography>
            <CheckCircleOutlineIcon sx={{ color: "green", fontSize: 32 }} />
          </Box>

          {/* Aadhaar Card Verified */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 3,
              backgroundColor:themeMode==="light"?"0px 4px 20px rgb(255, 255, 255)":"0px 4px 20px rgba(255, 255, 255, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // transition: "0.3s",
              // "&:hover": { backgroundColor: "#f1f1f1" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{color:theme.text}}>
              Aadhaar Card
            </Typography>
            <CheckCircleOutlineIcon sx={{ color: "green", fontSize: 32 }} />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default KYCCompleted;
